import React, { useState, useEffect, useRef } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';


import { 
    Layout,
    Table,
    Col, 
    Row,
    Button,
    // Modal,
    Upload,
    Divider,
    Form,
    Select,
    Input,
    DatePicker,
    Radio,
    InputNumber,
    Image,
    Space,
} from 'antd'
import { InboxOutlined } from '@ant-design/icons';
import { capitalizeText, formatAmount } from '../../Utils/Common';
import { useNavigate } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import '../../CssFiles/AddPayment.css';
import NoData from "../../Assets/error-data.png"

// const { Search } = Input;
const { TextArea } = Input;
const { Option } = Select;
const { Item } = Form;

// Display-only preview: the API validates balances and allocates the saved payment.
const billingOutstanding = (billing) => Number(billing.balance) || 0;

const AddPayment = () => {
  const [addPaymentForm] = Form.useForm();
  const navigate = useNavigate()
  const { 
    callPost, 
    loading, 
    // data 
  } = usePostRequest(()=>{
    addPaymentForm.resetFields();
    navigate(-1)
  });
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [selectedBillingIds, setSelectedBillingIds] = useState([]);
  const billingRequestId = useRef(0);
  const selectedBillings = paymentData.filter((billing) => selectedBillingIds.includes(billing.id));
  const [memberData, setMemberData] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [memberId, setMemberId] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [grandTotal, setGrandTotal] = useState(0);
  const values = Form.useWatch([], addPaymentForm);
  React.useEffect(() => {
      addPaymentForm.validateFields({
      validateOnly: true,
      }).then(() => {
      setIsDisabled(false);
      },
      () => {
      setIsDisabled(true);
      },
      );
  }, [values, addPaymentForm]);

  const validatePaymentArrayObjects = () => (
    selectedBillings.length === 0 || selectedBillings.some((item) => {
      const amount = Number(item.payment_amount);
      return !Number.isFinite(amount) || amount <= 0 || amount > billingOutstanding(item);
    })
  );

  async function fetchBillingData(member_id) {
    const requestId = ++billingRequestId.current;
    setMemberId(member_id);
    setSelectedBillingIds([]);
    setPaymentData([]);
    const response = await UseGetRequest("billings/get_billing", {member_id, screen: "payment"});
    if (requestId !== billingRequestId.current) return;
    setPaymentData((response?.data?.billings || []).map((billing) => ({
      ...billing,
      billing_items: billing.billing_items || [],
      payment_amount: billingOutstanding(billing),
    })));
  }

    async function fetchMemberData(search) {
      const response = await UseGetRequest("members/get_all", {cust_term: search});
      if (response?.data) {
        const member_data = response?.data?.members.map((data) => ({
            ...data,
            full_name: data.last_name + ", " + data.first_name + " " + data.middle_name
        }))
        setMemberData(member_data);
      } else {
        setMemberData([]);
      }
    }

  const options = [
    {
      label: 'GCash',
      value: 'gcash',
    },
    {
      label: 'Cash',
      value: 'cash',
    },
    {
      label: 'Direct Deposit',
      value: 'direct_deposit',
    },
    {
      label: 'Credit Card',
      value: 'credit_card',
    },
    {
      label: 'Check',
      value: 'check',
    },
  ];

  const detailColumns = [
    {title: 'Description', dataIndex: 'particulars', render: capitalizeText},
    {title: 'Total', dataIndex: 'amount', align: 'right', render: (amount) => `₱${formatAmount(amount || 0)}`},
    {title: 'Previously paid', dataIndex: 'paid_amount', align: 'right', render: (amount) => `₱${formatAmount(amount || 0)}`},
    {title: 'Outstanding', dataIndex: 'balance', align: 'right', render: (amount) => `₱${formatAmount(amount || 0)}`},
  ];
  const columns = [
    {title: 'SA #', dataIndex: 'id'},
    {
      title: 'Description / Billing Period',
      render: (_, billing) => `Statement of Account — ${billing.period_covered || billing.billing_date}`,
    },
    {title: 'Total Amount', dataIndex: 'grand_total', render: formatAmount},
    {
      title: 'Payment Amount',
      render: (_, billing) => (
        <InputNumber
          style={{width: '100%'}}
          value={billing.payment_amount}
          disabled={!selectedBillingIds.includes(billing.id)}
          min={0}
          max={billingOutstanding(billing)}
          precision={2}
          onChange={(value) => setPaymentData((previous) => previous.map((item) => (
            item.id === billing.id ? {...item, payment_amount: value} : item
          )))}
        />
      ),
    },
    {
      title: 'Balance',
      render: (_, billing) => formatAmount(Math.max(0, billingOutstanding(billing) - (
        selectedBillingIds.includes(billing.id) ? Number(billing.payment_amount) || 0 : 0
      ))),
    },
    {
      title: 'Status',
      render: (_, billing) => {
        const outstanding = billingOutstanding(billing);
        return outstanding === 0 ? 'Paid' : outstanding < Number(billing.grand_total) ? 'Partial' : 'Unpaid';
      },
    },
  ];

  const onMethodChange = ({ target: { value } }) => {
    setPaymentMethod(value);
  };

  const handleAddPayment = () => {
    addPaymentForm.validateFields().then(values => {
      if (validatePaymentArrayObjects()) {
        toast.error("Select statements and enter valid payment amounts within their outstanding balances.");
        return;
      }
      const resetData = {
        member_id: memberId,
        mop: paymentMethod,
        remarks: values.remarks || "",
        or_no: values?.or_no || "",

        // Send one amount per selected SA; the backend selects its unpaid items.
        billing_ids: selectedBillings.map((billing) => billing.id),
        amounts: selectedBillings.map((billing) => Number(billing.payment_amount)),
      };

      resetData.date = values?.payment_date ? values.payment_date.format("YYYY-MM-DD") : "";

      if(paymentMethod === "gcash"){
        resetData.reference_no = values.reference_no.trim();
      } else if(paymentMethod === "direct_deposit"){
        resetData.bank_name = values?.deposit_bank ? values.deposit_bank : "";
        resetData.customer_id = values?.customer_id ? values.customer_id : "";
      } else if(paymentMethod === "credit_card"){
        resetData.bank_name = values?.credit_bank ? values.credit_bank : "";
        resetData.approval_code = values?.approval_code ? values.approval_code : "";
      } else if(paymentMethod === "check"){
        resetData.bank_name = values?.check_bank ? values.check_bank : "";
        resetData.check_date = values?.check_date ? values.check_date.format("YYYY-MM-DD") : "";
        resetData.check_no = values?.check_no ? values.check_no : "";
      }
      
      const file = attachmentsData.map((file) => {
        return file.originFileObj;
      });

      var finalValues = Object.entries({...resetData, attachments: file}).map(([key, value]) => ({
          key,
          value,
      }));

      callPost(
          "billing_payments/create", 
          finalValues,
          true,
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const handleDeleteAttachment = (file) => {
    const updatedAttachments = attachmentsData.filter(item => item !== file);
    setAttachmentsData(updatedAttachments);
  };

  const normFile = (e) => {

    if (Array.isArray(e)) {
        setAttachmentsData(e)
    }
    setAttachmentsData(e?.fileList)
    
  };

  useEffect(() => {
      fetchMemberData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  useEffect(() => {
    // Live preview only: sum entered payment amounts for checked SAs; unchecked SAs contribute zero.
    // Multiply pesos by 100 and round to whole centavos to avoid decimal errors when adding money.
    // The backend independently validates amounts, calculates the saved total and allocates payments.
    const totalCents = paymentData.reduce((total, billing) => total + (
      selectedBillingIds.includes(billing.id) ? Math.round((Number(billing.payment_amount) || 0) * 100) : 0
    ), 0);
    // Divide by 100 to display pesos in the Total label and the disabled Amount field.
    setGrandTotal(totalCents / 100);
    addPaymentForm.setFieldsValue({paid_amount: totalCents / 100});
  }, [paymentData, selectedBillingIds, addPaymentForm]);
  return (
    <Layout className='page'>
        <Navbar/>
        <Layout className='content-container overflow-y'>
            <Row>
                <Col span={24} className='header-container p-3'>
                    ADD PAYMENT
                </Col>
            </Row>
            <Row>
                <Col span={24} className='p-3'>
                    <Form form={addPaymentForm} layout="vertical">
                      <Divider className='divider-text'>Payee Info</Divider>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={8} className='p-2'>
                          <Item
                            label="Member Name"
                            name="member_id"
                            rules={[{ required: true, message: 'Please select your Member Name' }]}
                          >
                            <Select 
                              placeholder="Select a Member Name" 
                              onChange={(e) => fetchBillingData(e)}
                              showSearch
                              filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {memberData.map((option) => (
                                <Option key={option.id} value={option.id}>{option.full_name}</Option>
                              ))}
                            </Select>
                          </Item>
                        </Col>
                      </Row>
                      <Divider className='divider-text'>List of Billings</Divider>
                      {
                        validatePaymentArrayObjects() && (
                          <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                            <Col span={24} className='p-3 logout-icon'>
                            </Col>
                          </Row>
                        )
                      }
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={24} className='p-2'>
                          {
                            (paymentData.length === 0) ? (
                              <div className='center'>
                                <Image
                                  width={200}
                                  src={NoData}
                                  alt="Your Image"
                                  preview={false}
                                />
                              </div>
                            ) : (
                              <Table
                                rowKey="id"
                                dataSource={paymentData}
                                columns={columns}
                                pagination={false}
                                rowSelection={{
                                  selectedRowKeys: selectedBillingIds,
                                  onChange: setSelectedBillingIds,
                                  getCheckboxProps: (billing) => ({disabled: billingOutstanding(billing) <= 0}),
                                }}
                                expandable={{
                                  expandedRowRender: (billing) => (
                                    <Table className="payment-breakdown" rowKey="id" dataSource={billing.billing_items} columns={detailColumns} pagination={false} size="small" />
                                  ),
                                  rowExpandable: (billing) => billing.billing_items.length > 0,
                                }}
                              />
                            )
                          }
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                        <Col span={12}>
                        
                        </Col>
                        <Col span={12} className='p-3 amount-total' align='right'>
                          Total: {formatAmount(grandTotal)}
                        </Col>
                      </Row>
                    
                      <Divider className='divider-text'>Add Payment</Divider>
                      <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                        <Col span={24} className='p-2'>
                            <Radio.Group options={options} onChange={onMethodChange} value={paymentMethod} optionType="button" />
                        </Col>
                      </Row>

                      <Form form={addPaymentForm} layout="vertical">
                        <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                          <Col span={8} className='p-2'>
                            <Item
                              label="Amount"
                              name="paid_amount"
                              className='p-0 m-0'
                              // rules={[{ required: true, message: 'Please enter your Name!' }]}
                            >
                              <InputNumber
                                style={{width:'100%'}}
                                disabled
                              />
                            </Item>
                          </Col>
                          <Col span={8} className='p-2'>
                            <Item
                              label="Payment Date"
                              name="payment_date"
                              className='p-0 m-0'
                              rules={[{ required: true, message: 'Please enter your Payment Date!' }]}
                            >
                              <DatePicker style={{width:'100%'}}/>
                            </Item>
                          </Col>
                          <Col span={8} className='p-2'>
                            <Item
                              label="OR Number"
                              name="or_no"
                              className='p-0 m-0'
                            >
                              <Input/>
                            </Item>
                          </Col>
                        </Row>
                        <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                          {
                            paymentMethod === "gcash" && (
                              <Col span={8} className='p-2'>
                                <Item
                                  label="Reference Number"
                                  name="reference_no"
                                  className='p-0 m-0'
                                  preserve={false}
                                  rules={[{ required: true, whitespace: true, message: 'Please enter your GCash Reference Number!' }]}
                                >
                                  <Input placeholder="Enter GCash reference number" />
                                </Item>
                              </Col>
                            )
                          }
                          {
                            paymentMethod === "direct_deposit" && (
                              <>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Bank Name"
                                    name="deposit_bank"
                                    className='p-0 m-0'
                                    rules={
                                      [
                                        { required: true, message: 'Please enter your Bank Name!' }
                                      ]
                                    }
                                  >
                                    <Input/>
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Customer ID"
                                    name="customer_id"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Customer ID!' }]}
                                  >
                                     <Input/>
                                  </Item>
                                </Col>
                              </>
                            )
                          }
                          {
                            paymentMethod === "credit_card" && (
                              <>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Bank Name"
                                    name="credit_bank"
                                    className='p-0 m-0'
                                    rules={
                                      [
                                        { required: true, message: 'Please enter your Bank Name!' }
                                      ]
                                    }
                                  >
                                    <Input/>
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Approval Code"
                                    name="approval_code"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Customer ID!' }]}
                                  >
                                     <Input/>
                                  </Item>
                                </Col>
                              </>
                            )
                          }
                          {
                            paymentMethod === "check" && (
                              <>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Bank Name"
                                    name="check_bank"
                                    className='p-0 m-0'
                                    rules={
                                      [
                                        { required: true, message: 'Please enter your Bank Name!' }
                                      ]
                                    }
                                  >
                                    <Input/>
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Check Date"
                                    name="check_date"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Check Date!' }]}
                                  >
                                    <DatePicker style={{width:'100%'}}/>
                                  </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                  <Item
                                    label="Check Number"
                                    name="check_no"
                                    className='p-0 m-0'
                                    rules={[{ required: true, message: 'Please enter your Check Number!' }]}
                                  >
                                    <Input/>
                                  </Item>
                                </Col>
                              </>
                            )
                          }
                        </Row>
                        <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-3'>
                          <Col span={24} className='p-2'>
                            <Item
                              label="Remarks"
                              name="remarks"
                              className='p-0 m-0'
                            >
                              <TextArea
                                rows={4}
                              />
                            </Item>
                          </Col>
                        </Row>
                        <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-3'>
                          <Col span={24} className='p-2'>
                            <Item 
                              label="Attachment"
                              name="attachments" 
                              // valuePropName="fileList" 
                              getValueFromEvent={normFile} 
                              noStyle
                            >
                              <Upload.Dragger 
                                multiple
                                name="files" 
                                // action="/upload.do"
                                fileList={attachmentsData}               
                                beforeUpload={() => false}
                                onRemove={handleDeleteAttachment}
                              >
                              <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                              </p>
                              <p className="ant-upload-text">Click or drag file to this area to upload</p>
                              <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                              </Upload.Dragger>
                            </Item>
                          </Col>
                        </Row>
                      </Form>
                      <Row className='btn-footer'>
                        <Space className='p-2'>
                          <Button
                            onClick={() => navigate(-1)}
                            className='btn-header'
                          >
                            Cancel
                          </Button>
                        
                          <Button
                            onClick={handleAddPayment}
                            type='primary'
                            loading={loading}
                            className='btn-header'
                            disabled={
                              validatePaymentArrayObjects() ||
                              isDisabled
                            }
                          >
                            Save
                          </Button>
                        </Space>
                      </Row>
                    </Form>
                </Col>
            </Row>
        </Layout>
    </Layout>
  )
}

export default AddPayment
